<div dir="rtl" style="height: 100%;background-color: white !important;">
  <br>
  <br>
  <div class="d-flex justify-content-between px-4">
    <div style="align-self: center;">
      <h5>
        لتداول الاوراق المالية
      </h5>
    </div>
    <div style="max-width: 8%;">
      <img src="./assets/identity/logo.png">
    </div>
  </div>
  <br>
  <div class="text-center">
    <h2>فاتورة</h2>
  </div>
  <br>
  <hr>
  <div class="mx-2" style="page-break-after:always">
    <div class="p-3">
      <mark class="row mx-1 px-1 justify-content-center mb-4 p-1">
        <div class="col-4 d-flex justify-content-around">
          <div>
            <strong>فاتورة {{invoice.TransactionType}}: </strong>
          </div>
          <div>
            {{invoice.PostedSerial}}
          </div>
        </div>
        <div class="col-4 d-flex justify-content-around">
          <div>
            <strong>تاريخ الفاتورة: </strong>
          </div>
          <div>
            {{invoice.InvoiceDate | date:'shortDate' }}
          </div>
        </div>
        <div class="col-4 d-flex justify-content-around">
          <div>
            <strong>تاريخ التسوية: </strong>
          </div>
          <div>
            --------
          </div>
        </div>
      </mark>
      <div class="row mx-1">
        <div class="col-3 d-flex justify-content-around" style="text-align: start;">
          <div>
            <strong>اسم العميل: </strong>
          </div>
          <div>
            {{profile.SubNameA}}
          </div>
        </div>
        <div class="col-3 d-flex justify-content-around" style="text-align: start;">
          <div>
            <strong>كود التداول:</strong>
          </div>
          <div>
            {{profile.ExchangeCode}}
          </div>
        </div>
        <div class="col-3 d-flex justify-content-around" style="text-align: start;">
          <div>
            <strong>كود العميل:</strong>
          </div>
          <div>
            {{profile.RelationCode}}
          </div>
        </div>
        <div class="col-3" style="text-align: start;">
          <div>
            <strong>امين حفظ:</strong>
          </div>
          <div>
            <!-- {{invoice.Custodian}} -->
          </div>
        </div>
      </div>
    </div>
    <br>

    <div class="text-center">
      <small>
        <strong>
          نتشرف بالافادة انه تم {{invoice.TransactionType}} الاوراق المالية التالية لحسابكم
        </strong>
      </small>
    </div>
    <div class="row mx-1 px-2 justify-content-center mb-2">
      <div class="col-8 d-flex justify-content-around  p-2">
        <div>
          <strong>سهم:</strong>
        </div>
        <div>
          {{invoice.Symbolname}}
        </div>
        <div>
          {{invoice.SymbolCode}}
        </div>
        <div>
          {{invoice.MarketId}}
        </div>
      </div>
    </div>
    <table class="table table-sm">
      <thead>
        <tr>
          <th class="fit">رقم العملية</th>
          <th class="fit">الكمية</th>
          <th class="fit">السعر</th>
          <th class="fit">القيمة</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let invoice of invoice.Orders">
          <td class="fit">{{invoice.TicketNo}}</td>
          <td class="fit">{{invoice.TransactionQty}}</td>
          <td class="fit">{{invoice.TransactionPrice| number: "1.0":"en-US"}}</td>
          <td class="fit">{{invoice.OrderNumber}}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td class="fit">
            <h6>{{'total'|translate}}</h6>
          </td>
          <td class="fit">{{invoice.Qty}}</td>
          <td class="fit"></td>
          <td class="fit"></td>
        </tr>
      </tfoot>
    </table>
    <hr>
    <div class="row px-5">
      <div class="col-5">
        <ul>
          <li *ngFor="let item of invoice.InvoiceComm" class="d-flex justify-content-between">
            <div>{{item.CommName}}</div>
            <div>{{item.CommValue| number: "1.0":"en-US"}}</div>
          </li>
        </ul>
      </div>
    </div>
    <hr>

    <div class="row px-5">
      <div class="col-4 d-flex justify-content-between">
        <div>اجمالي الخدمات:</div>
        <div><strong>{{totalInvoiceComm}}</strong></div>
      </div>
      <div class="col-6 d-flex justify-content-around">
        <div>متوسط التكلفة:</div>
        <div><strong>{{invoice.AvgPrice | number: "1.0":"en-US"}}</strong></div>
      </div>
      <div class="col-4 d-flex justify-content-between">
        <div>صافي القيمة:</div>
        <div><strong>{{invoice.NetAmount}}</strong></div>
      </div>
    </div>
    <!-- 45.29 -->
  </div>

  <div class="divFooter" style="bottom:15px;position: absolute; width: 100%;">
    <div class="row">
      <div class="col-5 d-flex justify-content-around">
        <div>طبع بواسطة</div>
        <div>{{profile.SubNameA}}</div>
      </div>
      <div class="col-2">
      </div>
      <div class="col-5 d-flex justify-content-around">
        <div>تاريخ الطباعة</div>
        <div>{{today |date:'medium'}}</div>
      </div>
    </div>
  </div>

</div>
